module.exports = __webpack_public_path__ + "static/media/group-coaching.b0de3890.svg";